import { CustomFormConfig } from "../types";

export const customFormConfig: CustomFormConfig = {
  sections: [
    {
      id: "personal_info",
      title: "Personal Information",
      enabled: true,
      fixedEnabled: true,

      fields: [
        {
          key: "first_name",
          label: "First Name",
          type: "text",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,
        },

        {
          key: "last_name",
          label: "Last Name",
          type: "text",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,
        },

        {
          key: "email",
          label: "Email ID",
          type: "email",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,
        },

        {
          key: "phone",
          label: "Mobile Number",
          type: "phone",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,
        },

        {
          key: "dob",
          label: "Date of Birth",
          type: "date",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,
        },

        {
          key: "gender",
          label: "Gender",
          type: "select",
          required: true,
          fixedRequired: true,
          fixedEnabled: true,
          enabled: true,

          options: [
            { label: "Male", value: "Male" },
            { label: "Female", value: "Female" },
            { label: "Other", value: "Other" },
          ],
        },

        /*
        |--------------------------------------------------------------------------
        | Optional Fields
        |--------------------------------------------------------------------------
        */

        {
          key: "selfie",
          label: "Upload profile picture",
          type: "file",
          enabled: false,
        },

        {
          key: "tshirt_size",
          label: "T-Shirt Size",
          type: "select",
          enabled: true,
          fixedRequired: true,
          fixedEnabled: true,

          options: [
            { label: "XS", value: "XS" },
            { label: "S", value: "S" },
            { label: "M", value: "M" },
            { label: "L", value: "L" },
            { label: "XL", value: "XL" },
            { label: "XXL", value: "XXL" },
          ],
        },

        {
          key: "nationality",
          label: "Nationality",
          type: "text",
          enabled: false,
        },

        {
          key: "country",
          label: "Country",
          type: "text",
          enabled: false,
        },

        {
          key: "state",
          label: "State",
          type: "text",
          enabled: false,
        },

        {
          key: "city",
          label: "City",
          type: "text",
          enabled: false,
        },

        {
          key: "address",
          label: "Address",
          type: "textarea",
          enabled: false,
        },

        {
          key: "pincode",
          label: "Pincode",
          type: "number",
          enabled: false,
        },

        {
          key: "running_club",
          label: "Name of Running Club",
          type: "text",
          enabled: false,
        },
      ],
    },

    /*
    |--------------------------------------------------------------------------
    | ID Proof
    |--------------------------------------------------------------------------
    */

    {
      id: "id_proof",
      title: "ID Proof",
      enabled: false,
      parentControlled: true,

      fields: [
        {
          key: "id_type",
          label: "ID Type",
          type: "select",
          enabled: true,

          options: [
            { label: "Aadhaar Card", value: "Aadhaar Card" },
            { label: "Driving License", value: "Driving License" },
            { label: "Passport", value: "Passport" },
            { label: "Voter ID", value: "Voter ID" },
          ],
        },

        {
          key: "id_number",
          label: "ID Number",
          type: "text",
          enabled: true,
        },

        {
          key: "id_upload",
          label: "Upload ID",
          type: "file",
          enabled: true,
        },
      ],
    },

    /*
    |--------------------------------------------------------------------------
    | Timing Certificate
    |--------------------------------------------------------------------------
    */

    {
      id: "timing_certificate",
      title: "Timing Certificate",
      enabled: false,
      parentControlled: true,

      fields: [
        {
          key: "timing_certificate",
          label: "Upload Certificate",
          type: "file",
          enabled: true,
        },

        {
          key: "timing_certificate_category",
          label: "Race Category",
          type: "select",
          enabled: true,

          options: [
            { label: "5K", value: "5 KM" },
            { label: "10K", value: "10 KM" },
            { label: "Half Marathon", value: "Half Marathon" },
            { label: "Full Marathon", value: "Full Marathon" },
            { label: "Ultra Marathon", value: "Ultra Marathon" },
          ],
        },

        {
          key: "completed_race_hours",
          label: "Hours",
          type: "number",
          enabled: true,
        },

        {
          key: "completed_race_minutes",
          label: "Minutes",
          type: "number",
          enabled: true,
        },

        {
          key: "completed_race_seconds",
          label: "Seconds",
          type: "number",
          enabled: true,
        },
      ],
    },

    /*
    |--------------------------------------------------------------------------
    | Emergency Contact
    |--------------------------------------------------------------------------
    */

    {
      id: "emergency",
      title: "Emergency Contact Information",
      enabled: false,
      parentControlled: true,

      fields: [
        {
          key: "emergency_name",
          label: "Emergency Contact Name",
          type: "text",
          required: true,
          enabled: true,
        },

        {
          key: "emergency_relation",
          label: "Relation",
          type: "text",
          enabled: true,
        },

        {
          key: "emergency_phone",
          label: "Emergency Contact Number",
          type: "phone",
          required: true,
          enabled: true,
        },
      ],
    },

    /*
    |--------------------------------------------------------------------------
    | Medical Information
    |--------------------------------------------------------------------------
    */

    {
      id: "medical",
      title: "Medical Information",
      enabled: false,

      fields: [
        {
          key: "blood_group",
          label: "Blood Group",
          type: "select",
          enabled: true,

          options: [
            { label: "A+", value: "A+" },
            { label: "A-", value: "A-" },
            { label: "B+", value: "B+" },
            { label: "B-", value: "B-" },
            { label: "O+", value: "O+" },
            { label: "O-", value: "O-" },
            { label: "AB+", value: "AB+" },
            { label: "AB-", value: "AB-" },
          ],
        },

        {
          key: "medical_conditions",
          label: "Medical Conditions",
          type: "textarea",
          enabled: true,
        },
      ],
    },

    /*
    |--------------------------------------------------------------------------
    | Terms
    |--------------------------------------------------------------------------
    */

    {
      id: "terms",
      title: "Terms & Conditions",
      enabled: false,
      parentControlled: true,

      fields: [
        {
          key: "accept_terms",
          label: "I agree to the Terms & Conditions",
          type: "checkbox",
          required: true,
          enabled: true,
        },
      ],
    },
  ],
};
